import React, { lazy, Suspense } from "react";
var ExecutionEnvironment = require("exenv");
import CustomMeta from "../components/CustomMeta/CustomMeta";
import PropTypes from "prop-types";

// Components
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const ConnectedWebsites = lazy(() =>
  import(
    /* webpackChunkName: "ConnectedWebsites" */ "../components/ConnectedWebsites/ConnectedWebsites"
  )
);

import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  mainDiv: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(0, 2),
    paddingBottom: theme.spacing(2),
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#f8f9fa",
  },
  headerSection: {
    backgroundColor: "white",
    borderBottom: "1px solid #e0e0e0",
    padding: theme.spacing(2, 0),
    marginBottom: theme.spacing(2),
  },
  headerContent: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(0, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: "#1a1a1a",
  },
  subTitle: {
    fontSize: 20,
    textAlign: "center",
  },
}));

function automate(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Automate your Social Media Marketing - Content Generator`}
        description={`Automate your content marketing by connecting your website. Generate 4 weeks of content for your social media accounts.`}
        url={`https://contentgenerator.io/automate`}
      />
      <div className={classes.headerSection}>
        <div className={classes.headerContent}>
          <Typography variant="h1" className={classes.heading}>
            Automate your Social Media Marketing (BETA)
          </Typography>
          <Typography className={classes.subTitle}>
            Connect a website to generate 4 weeks of content every month.
          </Typography>
        </div>
      </div>
      <div className={classes.mainDiv}>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <ConnectedWebsites />
          </Suspense>
        )}
      </div>
    </div>
  );
}

automate.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(automate);
